import React from 'react';
const STEPS = [{
  num: '1',
  title: 'Get Your Free Quote',
  description: 'Call or book online. We provide fast, transparent pricing for your project.'
}, {
  num: '2',
  title: 'We Arrive On Time',
  description: 'Our uniformed crew arrives with professional-grade equipment ready to work.'
}, {
  num: '3',
  title: 'Sit Back & Relax',
  description: 'Relax while we get to work and get your plumbing working perfectly again.'
}];
export function Process() {
  return <section className="py-24 bg-surface border-y border-accent/10" data-id="element-163">
      <div className="container mx-auto px-4" data-id="element-164">
        <div className="mb-16 relative h-64 md:h-80 rounded-2xl overflow-hidden shadow-2xl border-2 border-accent/20 max-w-5xl mx-auto" data-id="element-165">
          <img src="https://images.unsplash.com/photo-1584622781564-1d987f7333c1?q=80&w=1200&auto=format&fit=crop" alt="Modern walk-in shower with clean tile and fixtures" className="w-full h-full object-cover" data-id="element-166" />
          <div className="absolute inset-0 bg-dark/60 flex items-center justify-center" data-id="element-167">
            <h2 className="font-display text-4xl md:text-6xl text-white uppercase tracking-wide text-center px-4" data-id="element-168">
              How It <span className="text-accent" data-id="element-169">Works</span>
            </h2>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-start gap-12 lg:gap-8 max-w-5xl mx-auto" data-id="element-170">
          {STEPS.map((step, idx) => <div key={idx} className="flex-1 flex flex-col items-center text-center relative w-full" data-id="element-171">
              {idx < STEPS.length - 1 && <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] h-0.5 border-t border-dashed border-accent/50" data-id="element-172" />}
              <div className="relative z-10 w-16 h-16 rounded-full bg-dark border-2 border-accent flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-173">
                <span className="font-display text-3xl text-white" data-id="element-174">
                  {step.num}
                </span>
                <div className="absolute -top-3 -right-2" data-id="element-175">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-176">
                    <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#dc2626" stroke="#0c0a0a" strokeWidth="2" strokeLinejoin="round" data-id="element-177" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-178">
                {step.title}
              </h3>
              <p className="text-slate-400 max-w-xs" data-id="element-179">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}